import DataAccess from './constants';
import { genfunction } from '../helpers';
const path = 'BookingTypes'

export const apiBookingTypes = (id, isDisplayArea) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let newID = typeof id === 'object' && id !== null ? id.DisplayAreaNo : id;
    let newIsDisArea = typeof id === 'object' && id !== null ? id.isDisplay : isDisplayArea;

    const url = DataAccess.apiUrl + path + (newIsDisArea ? "?DisplayArea=" + newID : "?BookingTypeID=" + newID)

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}